import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import GlobalGalleryService from "./GalleryImageService";


export const getGlobalGallerys = createAsyncThunk("GlobalGallery/get-GlobalGallerys", async (thunkAPI) => {
  try {
    return await GlobalGalleryService.getGlobalGallerys();
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
}); 
export const createGlobalGallery = createAsyncThunk(
  "GlobalGallery/create-GlobalGallerys",
  async (AssociationData, thunkAPI) => {
    try {
      return await GlobalGalleryService.createGlobalGallery(AssociationData);
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  }
);

export const getGlobalGallery = createAsyncThunk(
  "GlobalGallery/get-GlobalGallery",
  async (id, thunkAPI) => {
    try {
      return await GlobalGalleryService.getGlobalGallery(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const updateGlobalGallery = createAsyncThunk(
  "GlobalGallery/update-GlobalGallery",
  async (id, thunkAPI) => {
    try {
      return await GlobalGalleryService.updateGlobalGallery(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteGlobalGallery = createAsyncThunk(
  "GlobalGallery/delete-GlobalGallery",
  async (id, thunkAPI) => {
    try {
      return await GlobalGalleryService.deleteGlobalGallery(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);
export const resetState = createAction("Reset_all");

const initialState = {
  GlobalGallerys: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const AssociationSlice = createSlice({
  name: "GlobalGallery",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getGlobalGallerys.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGlobalGallerys.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.GlobalGallerys = action.payload.data;
      })
      .addCase(getGlobalGallerys.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createGlobalGallery.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createGlobalGallery.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.createdGlobalGallery = action.payload;
      })
      .addCase(createGlobalGallery.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.payload;
      })

      .addCase(getGlobalGallery.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getGlobalGallery.fulfilled, (state, action) => {
        state.isLoading = false; 
        state.isError = false;
        state.isSuccess = true;
        state.GlobalGallerysplace = action.payload.data.place;
        console.log(action.payload.data.place);
        state.GlobalGalleryhitUrl = action.payload.data.hitUrl;
      })
      .addCase(getGlobalGallery.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateGlobalGallery.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateGlobalGallery.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedGlobalGallery = action.payload;
      })
      .addCase(updateGlobalGallery.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteGlobalGallery.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteGlobalGallery.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedGlobalGallery = action.payload;
      })
      .addCase(deleteGlobalGallery.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default AssociationSlice.reducer;
